<template>
    <div v-bind:class="$style.container">
        <VTextField
            v-model="query"
            type="text"
            placeholder="What can we help you discover?"
            v-bind:class="$style.search"
            solo
            flat
            autofocus
            color="grey darken-3"
            append-icon="$vuetify.icons.search"
            v-on:keypress.enter="search"
            v-on:click:append="search"
        />
    </div>
</template>

<script>
    import MediaQueries from '@mixins/MediaQueries';

    export default {
        /**
         * Mixins are a flexible way to distribute reusable functionalities for Vue components.
         * A mixin object can contain any component options. When a component uses a mixin,
         * all options in the mixin will be “mixed” into the component’s own options.
         *
         * @link https://vuejs.org/v2/guide/mixins.html
         */
        mixins: [
            MediaQueries,
        ],

        /**
         * You must define defaults for all Vue models and reactive Vue template data.
         *
         * @link https://vuejs.org/v2/api/#data
         *
         * @return Object Vue model and binding defaults.
         */
        data () {
            return {
                query: '',
            };
        },

        /**
         * Non-cached methods that are used by the Vue instance and template.
         *
         * @type Object ES6 methods
         */
        methods: {
            /**
             * Redirect to the search page.
             *
             * @return void
             */
            search () {
                this.$router.push({
                    name: 'search',
                    query: {
                        query: this.query,
                    },
                });
            },
        },
    };
</script>

<style lang="scss" module>
    @import '@design';

    .container {
        @apply flex items-center max-w-full w-full px-10;
    }

    .search {
        height: 3.5rem;

        // Use direct element nesting to add a one-time modification to the proper Vuetify text field element
        > div {
            > div:first-child {
                @apply border border-solid border-gray-400;
            }
        }
    }
</style>
